
export const ENTITY_ID_PREFIX = 'EA';

export const AVAILABLE_ENTITY_TAGS = [
    'adverse_media',
    'pep',
    'sanctions',
    'legal_enforcement',
    'local_politicians',
    'whitelists',
    'public_functions',
] as const;

export type EntityTag = (typeof AVAILABLE_ENTITY_TAGS)[number];

export const AVAILABLE_STATISTICS_ORIGINS = [
    'entities',
    'batch_screening',
] as const;

export type StatisticsOrigin = (typeof AVAILABLE_STATISTICS_ORIGINS)[number];

export interface MostSearchedName {
    name: string;
    searched_count: number;
}

export interface MostSearchedNamesResponse {
    most_searched: MostSearchedName[];
}

export interface MostMonitoredName {
    name: string;
    monitored_count: number;
}

export interface MostMonitoredNamesResponse {
    most_monitored: MostMonitoredName[];
    /** ISO timestamp of the last statistics extraction, null if it failed */
    last_updated: string | null;
}

export interface MostSearchedTag {
    tag: string;
    searched_count: number;
}

export interface MostSearchedTagsResponse {
    most_searched: MostSearchedTag[];
}

/** Shows an entity as "name (ID)", or just the ID when it has no name */
export const formatEntityLabel = (id: string, name?: string | null): string =>
    name ? `${name} (${id})` : id;

export interface MostReturnedEntity {
    entity: string;
    name?: string | null;
    returned_count: number;
}

export interface MostReturnedEntitiesResponse {
    most_returned: MostReturnedEntity[];
}

export interface EntityEvidenceStatisticItem {
    entity_id: string;
    name?: string | null;
    requested_count: number;
}

export interface EntityEvidencesStatisticsResponse {
    most_requested: EntityEvidenceStatisticItem[];
}

export type TagsHistogramInterval = 'day' | 'month' | 'year';

export interface TagsHistogramBucket {
    date: string;
    count: number;
}

export interface TagsHistogramEntry {
    tag: string;
    total: number;
    buckets: TagsHistogramBucket[];
}

export interface TagsHistogramResponse {
    interval: TagsHistogramInterval;
    histogram: TagsHistogramEntry[];
}